import { useState } from "react";
import { Package, Check, MapPin } from "lucide-react";
import api, { formatErr } from "../lib/api";

export default function TrackPage() {
  const [code, setCode] = useState("");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr(""); setData(null);
    try { const r = await api.get(`/track/${encodeURIComponent(code.trim())}`); setData(r.data); }
    catch (e) { setErr(formatErr(e)); } finally { setLoading(false); }
  };
  return (
    <div className="max-w-2xl mx-auto px-6 py-20">
      <div className="overline mb-3">Order Tracking</div>
      <h1 className="font-display text-5xl text-dark mb-3">Track Shipment</h1>
      <p className="text-gray-500 mb-8">Enter your order number or DHL tracking ID below.</p>
      <form onSubmit={submit} className="flex gap-3">
        <input data-testid="track-page-input" required placeholder="LX-123456 or DHL number" className="input-box flex-1" value={code} onChange={(e)=>setCode(e.target.value)}/>
        <button data-testid="track-page-submit" className="btn-primary" disabled={loading}>{loading? "…":"Track"}</button>
      </form>
      {err && <div className="text-red-600 text-sm mt-4">{err}</div>}
      {data && (
        <div className="mt-12 card-luxe p-8">
          <div className="flex items-center justify-between mb-4">
            <div><div className="overline">Order</div><div className="font-display text-xl text-dark">{data.order_number}</div></div>
            <div className="text-right"><div className="overline">Status</div><div className="text-copper text-sm uppercase tracking-luxe">{data.status}</div></div>
          </div>
          <div className="text-xs text-gray-500 flex items-center gap-2 mb-6"><MapPin size={13}/> {data.shipping_city}, {data.shipping_country}{data.tracking_number && <> · DHL: {data.tracking_number}</>}</div>
          <div className="space-y-3">
            {data.timeline.map((t, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${t.done? "bg-copper text-white" : "bg-[#F5F2ED] text-gray-400 border border-black/10"}`}>
                  {t.done ? <Check size={14}/> : <Package size={14}/>}
                </div>
                <div className={`flex-1 text-sm ${t.done? "text-dark" : "text-gray-400"}`}>{t.status}</div>
              </div>
            ))}
          </div>
          {data.dhl_live && <div className="mt-5 text-xs text-gray-500 italic">{data.dhl_live.note}</div>}
        </div>
      )}
    </div>
  );
}
